import React from 'react';
import { Form } from '../../../ui/universe';
import { Radio, Tooltip } from 'tdesign-react';

/**
 * Switch 参数渲染器（使用 Radio 实现）
 */
function SwitchRenderer({ params, value, onChange }) {
  return (
    <Form.Item
      className={`${params.LabelAlign ? 'column' : 'row'}`}
      label={
        <>
          <span>{params.label}</span>
          {params.des && (
            <Tooltip content={params.des} theme="light">
              <span className="ocrDemo-icon-question"></span>
            </Tooltip>
          )}
        </>
      }
    >
      <Radio.Group
        value={value ? '1' : '2'}
        onChange={(val) => {
          const finalVal = val === '1';
          onChange && onChange(finalVal);
        }}
        className="unv-radio__group unv-radio__group--grid unv-radio__group--grid-3"
      >
        {params.options.map((op, index) => (
          <Radio key={index} value={op.value ? '1' : '2'}>
            <span>{op.text}</span>
            {op.des && (
              <Tooltip content={op.des} theme="light">
                <span className="ocrDemo-icon-question"></span>
              </Tooltip>
            )}
          </Radio>
        ))}
      </Radio.Group>
    </Form.Item>
  );
}

export default SwitchRenderer;
